import React from "react";
import {
  FaCircleCheck,
  FaCircleQuestion,
  FaCircleXmark,
} from "react-icons/fa6";
import { FaClock } from "react-icons/fa";

export const TimesheetStatusTextIcon = ({ status, hideText = false }) => {
  let icon, iconOnly;

  // Icons for pill display (white with margin)
  icon = (
    <FaCircleQuestion
      className={"me-2"}
      size={16}
      color={"white"}
    />
  );
  
  // Icons for table display (colored, no margin)
  iconOnly = (
    <FaCircleQuestion
      size={19}
      color={"#e69265"}
    />
  );

  if (status === "APPROVED") {
    icon = (
      <FaCircleCheck
        className={"me-2"}
        size={16}
        color={"white"}
      />
    );
    iconOnly = (
      <FaCircleCheck
        size={19}
        color={"#63e6be"}
      />
    );
  }
  
  if (status === "PENDING") {
    icon = (
      <FaClock className={"me-2"} size={16} color={"white"} />
    );
    iconOnly = (
      <FaClock size={19} color={"#9e70ff"} />
    );
  }
  
  if (status === "REJECTED") {
    icon = (
      <FaCircleXmark
        className={"me-2"}
        size={16}
        color={"white"}
      />
    );
    iconOnly = (
      <FaCircleXmark
        size={19}
        color={"#e66566"}
      />
    );
  }

  if (status === null || status === undefined) {
    if (hideText) {
      return iconOnly;
    }
    return (
      <span className={"icon-text-wrapper table-pill missing-pill"}>
        {icon} Missing
      </span>
    );
  }

  if (hideText) {
    return iconOnly;
  }

  return (
    <span
      className={
        "icon-text-wrapper text-capitalize table-pill " +
        status.toLowerCase() +
        "-pill"
      }
    >
      {icon} {status.toLowerCase()}
    </span>
  );
};
